// This wont work when server side rendering, make sure its only used after a <NoSSR> boundary
import { breakpoints } from '@99designs/emu/settings';

export function isDesktop() {
    return window.innerWidth >= breakpoints.normal[0];
}
